import { createFileRoute, redirect } from '@tanstack/react-router'

import { getUIVersion } from 'lib/uiVersion'

import UserDashboard from 'pages/Landing/UserDashboard'
import UserDashboardClassic from 'pages/Landing/UserDashboard.classic'

// Read once at module load -- version never changes without a full page reload
const IS_CLASSIC_UI = getUIVersion() === 'classic'

export const Route = createFileRoute('/_auth/dashboard')({
  beforeLoad: ({ context }) => {
    if (context.auth.global.view) {
      throw redirect({ to: context.auth.routing.home || '/search' })
    }
  },
  component: IS_CLASSIC_UI ? UserDashboardClassic : UserDashboard,
})
